import { NAV_LINKS } from '../constants';
const Footer= () => {
  return (
    <footer id="contact" className="bg-black pt-24 pb-12 border-t border-white/5">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Info */}
          <div className="lg:col-span-1">
            <div className="flex flex-col mb-6">
              <span className="text-2xl font-bold tracking-tighter text-white leading-none">ARVIND</span>
              <span className="text-sm font-medium tracking-[0.2em] text-gold leading-none">MERA SATHI</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-8">
              Premium Ayurvedic solutions for men's wellness and vitality. Experience the difference of nature's finest ingredients.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center text-gray-400 hover:text-gold transition-colors">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center text-gray-400 hover:text-gold transition-colors">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full glass flex items-center justify-center text-gray-400 hover:text-gold transition-colors">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest mb-8 border-b border-gold/30 pb-2 inline-block">Navigation</h4>
            <ul className="space-y-4">
              {NAV_LINKS.map(link => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-500 hover:text-gold transition-colors text-sm uppercase tracking-wider">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest mb-8 border-b border-gold/30 pb-2 inline-block">Get In Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="fas fa-map-marker-alt text-gold mt-1"></i>
                <span className="text-gray-500 text-sm">India's Leading Ayurvedic Performance House</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="fas fa-phone text-gold"></i>
                <span className="text-gray-500 text-sm">+91-XXXXXXXXXX</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="fas fa-envelope text-gold"></i>
                <span className="text-gray-500 text-sm">support@arvindmerasathi.com</span>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-widest mb-8 border-b border-gold/30 pb-2 inline-block">Vitality Newsletter</h4>
            <p className="text-gray-500 text-xs mb-4">Join our community for exclusive health tips and offers.</p>
            <form className="flex flex-col space-y-4">
              <input 
                type="email" 
                placeholder="Your Email Address" 
                className="bg-white/5 border border-white/10 px-4 py-3 text-sm focus:outline-none focus:border-gold"
              />
              <button className="bg-gold text-black font-bold uppercase tracking-widest py-3 hover:bg-white transition-all">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-600 text-[10px] uppercase tracking-[0.2em]">
          <p>Â© 2024 ARVIND MERA SATHI. ALL RIGHTS RESERVED.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">Shipping Policy</a>
          </div>
        </div>
      </div>

      {/* WhatsApp Sticky */}
      <a 
        href="https://wa.me/yournumber" 
        className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center text-2xl shadow-2xl hover:scale-110 transition-transform"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </footer>
  );
};

export default Footer;
